import { render, staticRenderFns } from "./OrderTypeCard.vue?vue&type=template&id=7be70a62&scoped=true&"
import script from "./OrderTypeCard.vue?vue&type=script&lang=ts&"
export * from "./OrderTypeCard.vue?vue&type=script&lang=ts&"
import style0 from "./OrderTypeCard.vue?vue&type=style&index=0&id=7be70a62&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be70a62",
  null
  
)

export default component.exports